import React from 'react';
import { PartnerProps, partners } from './constants';

interface SelectedPartnerProps {
  partner: PartnerProps | undefined;
  handleSelectPartner: (partnerId: number) => void;
  handleResetPartner: () => void;
}

const PARTNER_TERRA = 17;

const SelectedPartnerContext = React.createContext<SelectedPartnerProps>(
  {} as SelectedPartnerProps
);

export const SelectPartnerProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [partner, setPartner] = React.useState<PartnerProps | undefined>(() => {
    const saved = localStorage.getItem('selectedPartner');
    return saved ? JSON.parse(saved) : undefined;
  });

  const handleSelectPartner = (partnerId?: number) => {
    if (partnerId === PARTNER_TERRA) return;

    const getPartner = partners.find((p) => p.partnerNumber === partnerId);
    setPartner(getPartner);

    if (getPartner) {
      localStorage.setItem('selectedPartner', JSON.stringify(getPartner));
    } else {
      localStorage.removeItem('selectedPartner');
    }
  };

  const handleResetPartner = () => {
    setPartner(undefined);
    localStorage.removeItem('selectedPartner');
  };

  return (
    <SelectedPartnerContext.Provider
      value={{
        partner,
        handleSelectPartner,
        handleResetPartner,
      }}
    >
      {children}
    </SelectedPartnerContext.Provider>
  );
};

export function useSelectPartner(): SelectedPartnerProps {
  const context = React.useContext(SelectedPartnerContext);
  return context;
}
